'use client';
import { LoadingPageProvider } from '@/features/providers/loading-page-provider';
import { HomePage } from '@/jupiter/features/home-page';
import { siteService } from '@/services/site.service';
import { LicenseeTypeEnums } from '@nf/types/site';
import { useEffect } from 'react';
import { useRouter } from '@/navigation';
import { useLocale } from 'next-intl';
import { LoadingPage } from '@/components/core/loading-page';

export default function Home() {
	const router = useRouter();
	const locale = useLocale();

	useEffect(() => {
		if (siteService.getLicenseeType() === LicenseeTypeEnums.Api) {
			router.replace('/live', { locale });
		}
	}, [locale, router]);

	return siteService.getLicenseeType() === LicenseeTypeEnums.Athena?(
		<LoadingPageProvider>
			<HomePage />
		</LoadingPageProvider>
	) : (
		<LoadingPage />
	);
}